import { useEffect, useState } from 'react';
import VerificationInput from 'react-verification-input';
import rootStyles from '../Login/index.module.scss';
import classNames from 'classnames';
import styles from './index.module.scss';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useLoginService } from '../../services/loginService/index';
import formStyles from '../Login/LoginContent/index.module.scss';
import { isEmpty } from 'lodash';
import { useSignUpService } from '../../services/signUpService';
import BackButton from '../SignUp/BackButton';

function VerificationChallenge() {
  const {
    state: { challenge, errorMessage, forgotPassword },
  } = useLoginService();
  const {
    state,
    state: { isWelcomeState },
  } = useSignUpService();
  const [content, setContent] = useState<string>();

  const shouldHide = isEmpty(challenge) || forgotPassword.state !== undefined || !!isWelcomeState;

  useEffect(() => {
    setContent('');
  }, [shouldHide]);

  return (
    <div
      className={classNames(styles.root, formStyles.root, rootStyles.boxContainer, 'w-full', {
        [rootStyles.hide]: shouldHide,
      })}
    >
      {challenge?.onBack ? <BackButton onClick={() => challenge?.onBack?.()} /> : null}
      <div className={styles.content}>
        <span
          className={classNames(rootStyles.title, {
            [rootStyles.paddingTop]: challenge?.onBack,
          })}
        >
          Enter 6-digit verification code
        </span>
        <div className={styles.descriptionText}>
          {`We've sent an ${
            challenge?.params?.CODE_DELIVERY_DELIVERY_MEDIUM?.toLowerCase() === 'sms'
              ? 'SMS'
              : 'Email'
          } with a verification code to ${
            challenge?.params?.CODE_DELIVERY_DESTINATION
          }. The code will be valid for the next 10 minutes.`}
        </div>
        <VerificationInput
          onChange={(value) => setContent(value)}
          value={content}
          onComplete={challenge.onFinish}
          placeholder=""
          classNames={{
            container: styles.verificationInputContainer,
            character: styles.character,
            characterInactive: styles.characterInactive,
            characterSelected: styles.characterSelected,
          }}
        />
      </div>
      <Button
        onClick={() => challenge?.onResend?.()}
        variant="outlined"
        color="primary"
        className={classNames(styles.sendBtn, rootStyles.sendBtn)}
      >
        Resend code
      </Button>
      {errorMessage || state.errorMessage ? (
        <div className={formStyles.error}>{errorMessage || state.errorMessage}</div>
      ) : null}
    </div>
  );
}
export default observer(VerificationChallenge);
